<script setup lang="ts">
import { computed } from 'vue'

import { useFeatureTourSpot } from '@hooks/feature-tour/feature-tour-spot.hook'

defineOptions({
  name: 'FeatureTourSpot',
})

const props = withDefaults(defineProps<FeatureTourSpotProps>(), {
  targetSelector: '',
})

interface FeatureTourSpotProps {
  id: string
  targetSelector?: string
}

const idRef = computed(() => props.id)
const targetSelectorRef = computed(() => props.targetSelector)

const {
  root,
  isActiveSpot,
} = useFeatureTourSpot({
  id: idRef,
  targetSelector: targetSelectorRef,
})

</script>

<template>
  <div
    ref="root"
    :class="['ft-spot', { 'ft-spot--active': isActiveSpot }]"
  >
    <slot />
  </div>
</template>

<style lang="scss" src="@scss/components/Molecules/FeatureTour/FeatureTourSpot.scss" />
